import React, { useState, useRef } from 'react';
import axios from 'axios';
import CssBaseline from '@material-ui/core/CssBaseline';
import PrimarySearchAppBar from '../components/Appbar'
import Helmet from 'react-helmet';
import Typer from '../components/Typer';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import DonateBar from '../components/DonateBar';

import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import Typography from '@material-ui/core/Typography';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import abbreviate from 'number-abbreviate';

import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import Checkout from "../components/checkout";
import { useSnackbar } from "notistack";

import SuccessPopup from '../components/paymentSuccessModal';
import ModelCard from '../components/ModelCard'
import Footer from '../components/Footer';
import { ScrollbarContext } from 'react-scrollbars-custom';
import Paper from '@material-ui/core/Paper';
import MUILink from '@material-ui/core/Link';

//stripe publishable key
let stripePromise;
let subbed = false;

const CssTextField = withStyles({
    root: {
        '& .MuiInputBase-input': {
            fontSize: "40px",
            textAlign: "center",
            //width: "60px",
        },
    },
})(TextField);

const useStyles = makeStyles((theme) => ({
    '@global': {
        ul: {
            margin: 0,
            padding: 0,
            listStyle: 'none',
        },
    },
    heroContent: {
        padding: theme.spacing(8, 0, 6),
    },
    cardHeader: {
        backgroundColor:
            theme.palette.type === 'light' ? theme.palette.grey[200] : theme.palette.grey[700],
    },
    cardPricing: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'baseline',
        marginBottom: theme.spacing(2),
    },
    footer: {
        borderTop: `1px solid ${theme.palette.divider}`,
        marginTop: theme.spacing(8),
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3),
        [theme.breakpoints.up('sm')]: {
            paddingTop: theme.spacing(6),
            paddingBottom: theme.spacing(6),
        },
    },
}));

const Support = (props) => {
    const tiers = [
        {
            title: 'Once off',
            price: '15',
            description: [
                'Keep the site free forever',
                'Name on the thank you wall',
                // 'Exclusive models',
                'No account required',
            ],
            buttonText: 'Donate',
            buttonVariant: 'outlined',
            ref: useRef(null),
        },
        {
            title: 'Monthly',
            price: '4',
            description: [
                'Keep the site free forever',
                // 'Exclusive models',
                'Extra API credits',
                'Vote on the next goal',
                'Secret discord access',
            ],
            buttonText: 'Subscribe',
            buttonVariant: 'contained',
            ref: useRef(null),
        },
        {
            title: 'Brand Sponsor',
            description: [
                'Your logo on the front page',
                'Unlimited API access',
                'Offline library access',
                'Free month of display ads',
            ],
            buttonText: 'Contact us',
            buttonVariant: 'outlined',
            href: 'mailto:hi@duck.pizza',
        },
    ];

    const classes = useStyles();
    const [modalData, setModalData] = useState({ amount: 0, });
    const [stripeSecret, setStripeSecret] = useState(null);
    const [modalState, setModalState] = useState(false);
    const [successModal, setSuccessModal] = useState(false);


    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const openPaymentModal = (amount, once) => {

        //validation
        if (amount < 3.0) {
            enqueueSnackbar(`Donation must be larger than $3`, { variant: 'error', });
            return;
        }

        //must be logged in for monthly donation
        if (!once && !authed) {
            enqueueSnackbar(`You need an account to do that`, { variant: 'info', });
            return;
        }

        if (!once && subbed) {
            enqueueSnackbar(`You're already subbed! Cancel your current sub in settings first`, { variant: 'info', });
            return;
        }

        setModalData({
            amount,
            once,
        });

        setModalState(true);

        //only send intent for once off payment, sub is created on submit
        if (once) {
            axios.post("/api/payment/getIntent/", { amount })
                .then(res => {
                    console.log('set client secret as ' + res.data.clientSecret)
                    setStripeSecret(res.data.clientSecret);
                });
        }
    }

    const [artists, setArtists] = useState([]);

    const scrollbar = React.useContext(ScrollbarContext);
    React.useEffect(async () => {
        scrollbar.parentScrollbar.scrollToTop();

        //Get supported artists
        axios.get('/api/support/artists').then(resp => {
            setArtists(resp.data);
        });

        if (authed) {
            const resp = await axios.get('/api/me/settings');
            subbed = resp.data.subbed;
        }

    }, []);

    let stripekey = process.env.SITE_ROOT === 'http://127.0.0.1:3000' ?
        "pk_test_51InI68A30nBr4FzOTL8KgbkRbSq5leafwLFGpuuJ5DZb0Z2hpiJhJySafijneUFrKeQXFuca2YlVGhlycf8o0i7W009pcT03zG" :
        "pk_live_51InI68A30nBr4FzOwKDTf5FOHzCPV8bmkN0B5dVA2NDtajq3J3qqqgrmkIXhZX2qe6jbjTERaRrWShCZzu7liuss00SlZoQjJm";

    return (
        <Elements stripe={loadStripe(stripekey)}>
            <CssBaseline />
            <Helmet>
                <title>{`Support Poly Pizza!`}</title>
                <meta name="description" content={`Download thousands of low poly 3D models for free. No login required. Ready for AR/VR, Unity, Unreal or Godot.`} />
                <link rel="stylesheet" type="text/css" href="/css/stripe.css" />
            </Helmet>
            <PrimarySearchAppBar loggedIn={props.isLoggedIn} history={props.history} isLoading={props.isLoading} />

            <Container maxWidth="lg" style={{ paddingTop: '30px' }}>
                <Grid container direction="column" justifyContent="center" alignItems="center" spacing={3}>
                    <Grid item>
                        <Typer
                            heading="Supported by"
                            dataText={['You ❤', ...props.stats.names]}
                        />
                    </Grid>
                </Grid>
                <DonateBar stats={props.stats} />
            </Container>
            {/* Hero unit */}
            <Container maxWidth="md" component="main" className={classes.heroContent}>
                <Grid container spacing={6} direction="column">
                    <Grid item>
                        <Typography variant="h4" align="center" component="p" style={{ fontWeight: 400 }}>Our mission is simple:</Typography>
                    </Grid>

                    <Grid item container style={{ justifyContent: 'center' }}>
                        <Card className={classes.root} style={{ textAlign: 'center', width: '500px' }}>
                            <CardContent>
                                <Typography 
                                variant="h5" align="center" component="p" 
                                style={{ fontWeight: 500, padding: '5px' }}>
                                    Make the worlds largest low poly asset pack, free for everyone.
                                    </Typography>
                            </CardContent>
                        </Card>

                    </Grid>

                    {/* <Grid item>
                        <Typography variant="h5" align="center" component="p" style={{ fontWeight: 400 }}> We can’t do either without your help.</Typography>
                    </Grid> */}

                    <Grid item>
                        <Typography variant="h6" align="left" component="p" style={{ fontWeight: 400 }}>
                            With your support we can afford to pay our cloud hosting bills and commission artists to make more high quality models for the site.
                            Your support will also mean we can keep working on the site and continue to add features that other sites would normally charge for.
                            Help us build the world's largest free community sourced asset pack for everyone.
                        </Typography>
                    </Grid>

                    {/* Show supported artists */}

                    <Grid item>
                        <Paper className="p-5 pb-0">
                            <Typography variant="h5" align="center" component="p" style={{ fontWeight: 400 }}>Poly pizza proudly supports these artists:</Typography>
                            <div className='flex flex-row justify-center gap-8  py-7'>
                                {artists.map((artist, index) => (
                                    <div key={index} className='flex flex-col items-center'>
                                        <a href={`/u/${artist.username}`} target="_blank"><img src={artist.dp} className='rounded-full w-20 h-20' /></a>
                                        <Typography variant="h6" align="center" component="p" className='!my-2'>{artist.username}</Typography>
                                        <Typography color="textSecondary" variant="body1" align="center" component="p">{abbreviate(artist.modelCount)} models </Typography>
                                    </div>
                                ))}
                            </div>
                        </Paper>
                    </Grid>

                    <Grid item className='flex justify-center'>
                        <iframe
                            width="560"
                            height="315"
                            className='rounded-md !pointer-events-auto' src="https://www.youtube-nocookie.com/embed/G3k-zpufo3U"
                            title="YouTube video player"
                            frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen
                            referrerpolicy='strict-origin-when-cross-origin'
                        ></iframe>
                    </Grid>
                </Grid>
            </Container>

            <Container maxWidth="md" component="main" className="!my-12">
                <Grid container spacing={4} justify="center" alignItems="center">
                    {tiers.map((tier, index) => (
                        // Enterprise card is full width at sm breakpoint
                        <Grid item key={tier.title} xs={12} md={4}>
                            <Card>
                                <CardHeader
                                    title={tier.title}
                                    subheader={tier.subtitle}
                                    titleTypographyProps={{ align: 'center' }}
                                    subheaderTypographyProps={{ align: 'center' }}
                                    className={classes.cardHeader}
                                />
                                <CardContent>
                                    {tier.price && <div className={classes.cardPricing}>
                                        <Typography component="h2" variant="h3" color="textPrimary" style={{ position: 'relative', left: '0px', marginRight: '-30px' }}>$</Typography>
                                        <CssTextField
                                            variant="standard"
                                            defaultValue={tier.price}
                                            inputRef={tier.ref}
                                            onKeyPress={(e) => {
                                                if (e.target.value.toString().length >= 4)
                                                    return e.preventDefault();
                                            }}
                                            type="number"
                                        />
                                    </div>}
                                    <ul>
                                        {tier.description.map((line) => (
                                            <Typography component="li" variant="subtitle1" align="center" key={line}>
                                                {line}
                                            </Typography>
                                        ))}
                                    </ul>
                                </CardContent>
                                <CardActions>
                                    <Button fullWidth variant={tier.buttonVariant} color="primary"
                                        onClick={() => {

                                            openPaymentModal(tier.ref.current.value, index === 0)
                                        }}>
                                        {tier.buttonText}
                                    </Button>
                                </CardActions>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Container>

            <Container maxWidth={'lg'}>
              

                {/* Names */}
                <h2 className="font-normal text-center mt-16">Join the {props.stats.donations.length} supporters that help make the site possible</h2>
                <Paper className="flex gap-3 flex-wrap p-9 lg:mx-16 mb-14">
                    {
                        props.stats.donations.map((d) => {
                            const classes = `my-0 ${d.type == 'Big' && 'font-semibold'}`;

                            if (!d.hasAccount) return <p key={d.name} style={{ color: d.type == 'Big' ? '#fff' : '#fff' }} className={classes}>{d.name}</p>
                            return <MUILink  style={{ color: d.type == 'Big' ? '#fff' : '#fff' }} href={`/u/${d.name}`} target={"_blank"} key={d.name} className={classes}>{d.name}</MUILink>
                        })
                    }
                </Paper>

            </Container>

            <Checkout
                authed={props.isLoggedIn}
                amount={modalData.amount}
                onceOff={modalData.once}
                goal={props.stats.goal.feature.toLowerCase()}
                percentage={((modalData.amount / props.stats.goal.amount) * 100).toFixed(2)}
                open={modalState}
                setOpen={setModalState}
                clientSecret={stripeSecret}
                setSuccess={setSuccessModal}
            />

            <SuccessPopup
                open={successModal}
                // open={true}
                handleClose={() => setSuccessModal(false)}
                onceOff={modalData.once}
            />



            <Footer />

        </Elements>
    );
}

Support.getInitialProps = async ({ req, res, match, history, location, ...ctx }) => {

    const stats = await axios.get(`${process.env.SITE_ROOT}/api/support/getstats`).catch((e) => console.log(e.message));

    const isLoggedIn = req !== undefined ? ctx.authed : authed;  //if SSR, use authed from context, otherwise use local var;
    return { isLoggedIn, stats: stats.data, darkMode: ctx.darkMode };
}


export default Support;

